import { forwardRef } from 'react';

import { IconProps } from '.';

export const TableIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M15.25 4.38H4.75C4.55109 4.38 4.36032 4.45902 4.21967 4.59967C4.07902 4.74033 4 4.93109 4 5.13V14.87C4.00259 15.0681 4.08244 15.2574 4.22253 15.3975C4.36263 15.5376 4.55189 15.6174 4.75 15.62H15.25C15.4481 15.6174 15.6374 15.5376 15.7775 15.3975C15.9176 15.2574 15.9974 15.0681 16 14.87V5.13C16 4.93109 15.921 4.74033 15.7803 4.59967C15.6397 4.45902 15.4489 4.38 15.25 4.38ZM5.5 7.38H9.25V10H5.5V7.38ZM10.75 7.38H14.5V10H10.75V7.38ZM5.5 11.5H9.25V14.12H5.5V11.5ZM14.5 14.12H10.75V11.5H14.5V14.12Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default TableIcon;
